import { connect } from 'react-redux';
import BaseForm from '../BaseForm/BaseForm';
import {
  updatePayment,
  showError,
  clearErrors,
} from '../../redux/actions/payments';

class PaymentUpdateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: updatePayment,
      name: 'Payment',
      action: 'Update',
      type: 'update',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && isNaN(Number(data.total))) {
      this.setState({ errors: ['total'] });
      this.props.dispatch(showError('Please specify a total'));
      return false;
    }
    if (isIndex(1) && BaseForm.validator.isEmpty(data.type)) {
      this.setState({ errors: ['type'] });
      this.props.dispatch(showError('Please specify the payment type'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.origin)) {
      this.setState({ errors: ['origin'] });
      this.props.dispatch(showError('Please specify the payment origin'));
      return false;
    }
    return data;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('update.total', this.props.item.total) || 0);
    dispatch(actions.change('update.type', this.props.item.type || ''));
    dispatch(actions.change('update.origin', this.props.item.origin || ''));
  }
}

const mapStateToProps = ({ payments }) => ({
  model: payments,
  fields: BaseForm.fields.payments.updatePayment,
  values: {
    type: [
      { name: 'CASH', value: 'CASH' },
      { name: 'CARD', value: 'CARD' },
      { name: 'BACS', value: 'BACS' },
      { name: 'CHEQUE', value: 'CHEQUE' },
      { name: 'CREDIT-NOTE', value: 'CREDIT_NOTE' },
    ],
    origin: [
      { name: 'SYSTEM', value: 'SYSTEM' },
      { name: 'SAGEPAY', value: 'SAGEPAY' },
    ],
  },
});

export default connect(mapStateToProps)(PaymentUpdateForm);
